import React from 'react';
import AboutMeImg from '../../images/pngegg.png'
import '../../Style/ResponsiveBreakpoint.css'

const AboutMe = () => {
    return (
        <div className='row about_me_container'>
            <div className='col-md-6 aboutMeImg'>
                <img src={AboutMeImg} alt='' className='img-fluid' />
            </div>
            <div className='col-md-6 text-light'>
                <p><span className='text-capitalize heading-three'>About</span> <span className='text-uppercase text-light'> me</span></p>
                <h2 className='pb-4 text-color'>Why hire me for your next project?</h2>
                <p className='text-justify'>As a front-end web developer, I bring a unique combination of technical expertise and creative vision to every project I work on. With a strong background in HTML, CSS, and JavaScript, I have the technical know-how to turn even the most complex design concepts into fully functional, user-friendly web experiences.</p>
                <p>What sets me apart from other front-end developers, however, is my passion for design and user experience. I understand the importance of creating visually appealing and intuitive web designs that engage users and drive results. I work closely with clients to understand their goals and ensure that every project is delivered on time, on budget, and to the highest standards of quality. Whether you're launching a new website or revamping an existing one, I have the skills and experience to help you achieve your vision and meet your business objectives.</p>
                <button className='btn special-btn'>Learn More</button>
            </div>
        </div>
    );
};

export default AboutMe;